import { render, staticRenderFns } from "./RegisterProviders.vue?vue&type=template&id=2ea204d1"
import script from "./RegisterProviders.vue?vue&type=script&lang=js"
export * from "./RegisterProviders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports